/**
 * Reine Helfer fuer die Mitteilungsliste — ohne React, damit sie ohne jsdom
 * pruefbar sind. Die Komponenten daneben zeichnen nur.
 */
import { AppNotification, isUnread } from '../../services/notificationStore';

const MIN = 60_000;
const STD = 60 * MIN;
const TAG = 24 * STD;

/**
 * „vor 5 Min.", „vor 3 Std.", „gestern", „vor 4 Tagen", danach das Datum.
 *
 * Bewusst grob: eine Mitteilung ist kein Protokoll. Was aelter als eine
 * Woche ist, traegt das Datum — „vor 23 Tagen" muesste sonst jeder im Kopf
 * zurueckrechnen. Ein anderes Jahr nennt das Jahr.
 */
export const relativeTime = (iso: string | null | undefined, nowMs: number): string => {
    const t = iso ? Date.parse(iso) : NaN;
    if (!Number.isFinite(t)) return '';
    const diff = nowMs - t;
    if (diff < MIN) return 'gerade eben';
    if (diff < STD) return `vor ${Math.floor(diff / MIN)} Min.`;
    if (diff < TAG) return `vor ${Math.floor(diff / STD)} Std.`;
    const tage = Math.floor(diff / TAG);
    if (tage === 1) return 'gestern';
    if (tage < 7) return `vor ${tage} Tagen`;
    const d = new Date(t);
    const now = new Date(nowMs);
    return d.getFullYear() === now.getFullYear()
        ? d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })
        : d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/**
 * Ungelesene zuerst, innerhalb beider Bloecke die Reihenfolge des Speichers
 * (neueste zuerst). Stabil: gleiche Eingabe, gleiche Ausgabe.
 */
export const unreadFirst = (items: ReadonlyArray<AppNotification>): AppNotification[] => {
    const offen: AppNotification[] = [];
    const gelesen: AppNotification[] = [];
    for (const n of items) (isUnread(n) ? offen : gelesen).push(n);
    return [...offen, ...gelesen];
};

/** Zahl fuer die Glocke: 1–9 als Ziffer, darueber „9+", 0 als leer. */
export const badgeText = (count: number): string => {
    if (count <= 0) return '';
    return count > 9 ? '9+' : String(count);
};
